import axios from "axios";
import apiURI from "../Api";

export default class StoreService {
  async postRegisterStore(
    referee,
    username,
    email,
    documentNumber,
    fname,
    lname,
    password,
    currency,
    language,
    coupon,
    country,
    internationalCode,
    localCode,
    phoneNumber,
    latitude,
    longitude,
  ) {
    const registerStore = {
      cupominvite: coupon,
      referee: {
        username: referee,
      },
      latitude: typeof latitude === "string" ? parseFloat(latitude) : latitude,
      longitude: typeof longitude === "string" ? parseFloat(longitude) : longitude,
      currency: currency,
      store: {
        originRegister: JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))
          ? "MOBILE"
          : "WEB",
        documentNumber: null,
        email: email,
        firstname: fname,
        password: password,
        surname: lname,
        username: username,
        language: language,
        internationalCode: internationalCode,
        localCode: localCode,
        phoneNumber: phoneNumber,
        country: country,
      },
    };

    const response = await axios.post(`${apiURI}/store/register`, registerStore);

    return response.data;
  }

  async upgradeToStartSeller(token, username, transactionID, currency) {
    const bodyJson = {
      paymentGateway: { id: 1 },
      paymentMethod: { id: 1 },
      paymenttransactionID: transactionID,
      plan: { id: 4 },
      currency: currency,
      store: {
        username: username,
      },
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/store/upgradeToStartSeller`,
      data: bodyJson,
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  }
}
